export const markRoomAsRead = async (matrixClient, room, preferredEvent = null) => {
    if (!matrixClient || !room) {
        return null;
    }

    const events = room.getLiveTimeline?.().getEvents?.() || [];
    const event = preferredEvent?.getId?.()
        ? preferredEvent
        : [...events].reverse().find(candidate => candidate.getId?.());
    const eventId = event?.getId?.();
    if (!eventId) {
        return null;
    }

    await matrixClient.sendReadReceipt(event);
    room.setUnreadNotificationCount?.("total", 0);
    room.setUnreadNotificationCount?.("highlight", 0);
    return eventId;
};
